<template>
    <div>
        <input type="radio" />
        <img :src="radioButtonSource" />
    </div>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';
@Component({})
export default class RadioButtonControlsMobile extends Vue {
    @Prop()
    checked;
    @ngInject()
    AppearanceService;

    get radioButtonSource() {
        const isDarkMode = this.AppearanceService.isDarkModeActive();

        if (isDarkMode && !this.checked) {
            return '/img/svg-icons/radio_button_unchecked_light.svg';
        }
        if (this.checked) {
            return '/img/svg-icons/radio_button_checked.svg';
        }
        return '/img/svg-icons/radio_button_unchecked.svg';
    }
}
</script>
